import { render, staticRenderFns } from "./fieldPikaday.vue?vue&type=template&id=95d5ba34&lang=pug&"
import script from "./fieldPikaday.vue?vue&type=script&lang=js&"
export * from "./fieldPikaday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports